import {
  QueryClient,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { fetchUpdateRestriction } from './service';
import { RestrictionQueryKey } from '../../queryKeys';
import { useNotificationService } from '@/hooks/notifications/useNotificationService';

export function useUpdateRestriction() {
  const queryClient: QueryClient = useQueryClient();
  const { NotificationsService } = useNotificationService();

  function onSuccess() {
    queryClient.invalidateQueries({
      queryKey: [RestrictionQueryKey.Primary],
    });
    NotificationsService.success({ message: 'updated_restriction_message' });
  }

  const { isPending, mutate } = useMutation({
    onSuccess,
    mutationFn: fetchUpdateRestriction,
  });

  return {
    updateRestriction: mutate,
    loadingUpdateRestriction: isPending,
  };
}
